exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content .tableAll {\n  min-height: 550px; }\n  .tab-content .tableAll .nav-link {\n    padding: 0px; }\n  .tab-content .tableAll .badge {\n    padding: 0.5em 1em;\n    min-width: 80px; }\n  .tab-content .tab-pane {\n  padding-bottom: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/list/list.component.scss
// module id = ../../../../../src/app/views/list/list.component.scss
// module chunks = main